import { validateResponseHasSchema } from '@/shared/api/validation'
import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import { z } from 'zod'

const client = createClient(buildUrl(TargetSystem.CoreApi))

export const fetchUser = async (userId: string) => validateResponseHasSchema(
  client.sendGet(`users/${userId}`),
  z.object({
    data: z.object({
      id: z.string(),
      emailAddress: z.string().email(),
      firstName: z.string(),
      lastName: z.string(),
      name: z.string(),
      organisationId: z.number().int().gt(0),
      permissions: z.array(z.string()),
      flags: z.object({
        isValidator: z.boolean(),
        isTechnicalReviewer: z.boolean()
      })
    })
  })
).then(r => r.data)
